"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var dom_1 = require("../utils/dom");
var misc_1 = require("../utils/misc");
var misc_2 = require("./misc");
// These keyboard keys result in these movements.
var ARROW_KEY_DIRECTIONS = {
    ArrowLeft: { left: -1, top: 0 },
    ArrowRight: { left: 1, top: 0 },
    ArrowUp: { left: 0, top: -1 },
    ArrowDown: { left: 0, top: 1 },
};
var isArrowKey = function (e) {
    return Object.keys(ARROW_KEY_DIRECTIONS).indexOf(e.key) !== -1;
};
var arrowDown$ = misc_2.keyDowns$.pipe(operators_1.filter(isArrowKey));
var arrowUp$ = misc_2.keyUps$.pipe(operators_1.filter(isArrowKey));
/**
 * Create an Observable that enables drag-and-drop
 * and emits a stream of updated positions.
 */
exports.createKeyboardMoveObservable = function (_a) {
    var element = _a.element, onComplete = _a.onComplete, _b = _a.shouldConvertToPercent, shouldConvertToPercent = _b === void 0 ? true : _b;
    return arrowDown$.pipe(
    // We're custom-handling repeating with a timer observable
    operators_1.filter(function (e) { return !e.repeat; }), 
    // Repeat until keyup
    operators_1.switchMap(function (e) {
        var keyRepeat$ = rxjs_1.timer(0, 200).pipe(operators_1.takeUntil(arrowUp$), operators_1.map(exports.addToOffset(e, element)), operators_1.map(misc_1.convertOffsetToPercentOrPixels(shouldConvertToPercent, element.parentElement)));
        keyRepeat$.subscribe({
            complete: function () { return onComplete && onComplete(); },
        });
        return keyRepeat$;
    }));
};
/*
 * Adds 1% (10% if shift is pressed) to the offset of an HTML Element
 * in the direction of the currently-pressed arrow key.
 *
 */
exports.addToOffset = function (e, element) { return function () {
    var offsetAndSize = dom_1.offsetAndSizeOfElement(element);
    var sizeOfParent = dom_1.sizeOfElement(element.parentElement);
    var onePercentHorizontal = sizeOfParent.width * 0.01;
    var onePercentVertical = sizeOfParent.height * 0.01;
    var movement = ARROW_KEY_DIRECTIONS[e.key];
    var multiplier = e.shiftKey ? 5 : 1;
    return {
        left: onePercentHorizontal * movement.left * multiplier +
            offsetAndSize.left,
        top: onePercentVertical * movement.top * multiplier + offsetAndSize.top,
    };
}; };
//# sourceMappingURL=keyboardMove.js.map